<template lang="pug">
#setProfile.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='setProfile-tab')
  form
    .mb-3
      label.col-form-label {{ $t("ui.account_id") }}
      input.form-control(type="text" :placeholder="$store.getters.accountID" disabled)
    .mb-3
      label.col-form-label {{ $t("ui.full_name") }}
      input.form-control(type="text" :placeholder="$store.getters.username" disabled)
    .mb-3
      label.col-form-label {{ $t("ui.contact_number") }}
      input.form-control(type="text" :placeholder="$store.getters.contactNumber" disabled)
    .mb-3
      label.col-form-label {{ $t("ui.register_date") }}
      input.form-control(type="text" :placeholder="$moment($store.state.user.account.verified_date).format('YYYY-MM-DD')" disabled)
</template>

<script>
import ValidateResult from "@/library/ValidateResult"
export default {
  components: {
    ValidateResult
  },
  data(){
    return{
    } 
  },
  computed: {
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
}
</script>
<style lang="scss" scoped>
.form-control:disabled, .form-control[readonly]{
  background: #57456f;
}
</style>